import axios from "axios";

const API =
  process.env.REACT_APP_API_URL ||
  "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

/*
|--------------------------------------------------------------------------
| CLASSES — Staff Portal
|--------------------------------------------------------------------------
*/

export const getAllClassesForPortal = async () => {
  const { data } = await axiosInstance.get("/student-portal/classes");
  return data;
};

/*
|--------------------------------------------------------------------------
| SECTIONS — Staff Portal
|--------------------------------------------------------------------------
*/

export const getAllSectionsForPortal = async (classId) => {
  const url = classId
    ? `/student-portal/sections?classId=${classId}`
    : "/student-portal/sections";

  const { data } = await axiosInstance.get(url);
  return data;
};

/*
|--------------------------------------------------------------------------
| CREDENTIALS — Staff Portal
|--------------------------------------------------------------------------
*/

export const regenerateCredentialsPortal = async (id) => {
  const { data } = await axiosInstance.post(
    `/admin-students/regenerate-credentials/${id}`
  );
  return data;
};

/*
|--------------------------------------------------------------------------
| STUDENTS — Staff Portal
|--------------------------------------------------------------------------
*/

export const createStudentForPortal = async (data) => {
  const { data: res } = await axiosInstance.post(
    "/student-portal/create",
    data
  );
  return res;
};

export const getAllStudentsForPortal = async (filters = {}) => {
  const params = new URLSearchParams(filters).toString();
  const { data } = await axiosInstance.get(
    `/student-portal/all?${params}`
  );
  return data;
};

export const getStudentByIdForPortal = async (id) => {
  const { data } = await axiosInstance.get(`/student-portal/${id}`);
  return data;
};

export const updateStudentForPortal = async (id, data) => {
  const { data: res } = await axiosInstance.put(
    `/student-portal/update/${id}`,
    data
  );
  return res;
};